// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1djbC","overflowing":"ReadFullNote_overflowing__1m_Au"};